const toggle = document.querySelector(".menu-toggle");
const overlay = document.querySelector(".site-drawer-overlay");
const drawer = document.querySelector(".site-drawer");
const drawerMenuLinkEls = document.querySelectorAll(".site-drawer a");

function setDrawer(open) {
  document.body.classList.toggle("drawer-open", open);
  toggle.setAttribute("aria-expanded", open ? "true" : "false");
  drawer.setAttribute("aria-hidden", open ? "false" : "true");
  window.scrollTo(0, 0);
}

toggle.addEventListener("click", () => {
  const isOpen = document.body.classList.contains("drawer-open");
  setDrawer(!isOpen);
});

overlay.addEventListener("click", () => setDrawer(false));
drawerMenuLinkEls.forEach(function (drawerMenuLinkEl) {
  drawerMenuLinkEl.addEventListener("click", () => setDrawer(false));
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") setDrawer(false);
});

(function () {
  const navItems = document.querySelectorAll(
    ".site-drawer__nav-item--have-child",
  );

  navItems.forEach(function (navItem) {
    const topToggle = Array.from(navItem.children).find(function (child) {
      return (
        child.classList &&
        child.classList.contains("site-drawer__accordion-toggle")
      );
    });

    if (!topToggle) return;

    topToggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = navItem.classList.contains("is-open");

      navItems.forEach(function (otherNavItem) {
        otherNavItem.classList.remove("is-open");

        const otherTopToggle = Array.from(otherNavItem.children).find(
          function (child) {
            return (
              child.classList &&
              child.classList.contains("site-drawer__accordion-toggle")
            );
          },
        );

        if (otherTopToggle) {
          otherTopToggle.setAttribute("aria-expanded", "false");
        }

        otherNavItem
          .querySelectorAll(".site-drawer__accordion-item")
          .forEach(function (subItem) {
            subItem.classList.remove("is-open");

            const subToggle = Array.from(subItem.children).find(
              function (child) {
                return (
                  child.classList &&
                  child.classList.contains("site-drawer__accordion-toggle")
                );
              },
            );

            if (subToggle) {
              subToggle.setAttribute("aria-expanded", "false");
            }
          });
      });

      if (!isOpen) {
        navItem.classList.add("is-open");
        topToggle.setAttribute("aria-expanded", "true");
      }
    });

    const subItems = navItem.querySelectorAll(".site-drawer__accordion-item");

    subItems.forEach(function (subItem) {
      const subToggle = Array.from(subItem.children).find(function (child) {
        return (
          child.classList &&
          child.classList.contains("site-drawer__accordion-toggle")
        );
      });

      if (!subToggle) return;

      subToggle.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = subItem.classList.contains("is-open");

        subItems.forEach(function (otherSubItem) {
          otherSubItem.classList.remove("is-open");

          const otherSubToggle = Array.from(otherSubItem.children).find(
            function (child) {
              return (
                child.classList &&
                child.classList.contains("site-drawer__accordion-toggle")
              );
            },
          );

          if (otherSubToggle) {
            otherSubToggle.setAttribute("aria-expanded", "false");
          }
        });

        if (!isOpen) {
          subItem.classList.add("is-open");
          subToggle.setAttribute("aria-expanded", "true");
        }
      });
    });
  });
})();

console.log("hello");
